export function isPointerInBounds(view,{x:x,y:y}){const rect=view.getBoundingClientRect();return x>=rect.left&&x<=rect.right&&y>=rect.top&&y<=rect.bottom}